import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CommonLocale, ReportsLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import LabelText from "@/components/label-text/label-text.vue";
import { VersionGroupModule } from "@/modules/versiongroup";
import { VersionGroupModel } from "@/services/version-group";
import { VCSLevelModel } from '@/models/title-list-model';

@Component({
	components: {
		Select,
		LabelText,
		Option: Select.Option
	}
})
export default class VersionGroupSingleUnit extends Vue {
	@Prop({ default: [] }) vcsLevelUnits!: VCSLevelModel[];
	public selectedVersionGroupId = this.defaultVersionGroupId;
	public selectedUnitId: number = 0;

	get commonFieldVersionGroupText(): string {
		return fmtMsg(CommonLocale.CommonFieldVersionGroup);
	}

	get unitText() {
		return fmtMsg(ReportsLocale.ReportUnitText);
	}

	get defaultVersionGroupId() {
		return this.versionGroups.length && this.versionGroups[0].id;
	}

	get selectedVersionGroup() {
		return this.versionGroups.find((v) => v.id === this.selectedVersionGroupId) || ({} as VersionGroupModel);
	}

	get selectedUnit() {
		return this.vcsLevelUnits.find((v) => v.id === this.selectedUnitId);
	}

	get versionGroups() {
		const versions = VersionGroupModule.versionGroups;
		if (Array.isArray(versions)) {
			versions.sort((versionA, versionB) => {
				return versionA.name < versionB.name ? -1 : 1;
			});
			return versions;
		}
		return versions;
	}

	get unitsByVersionGroup() {
		return this.vcsLevelUnits.filter((u) => u.curriculumType == this.selectedVersionGroup.curriculumType);
	}

	@Watch("selectedVersionGroupId", { immediate: true })
	setUnitId() {
		this.selectedUnitId = this.unitsByVersionGroup.length && this.unitsByVersionGroup[0].id;
		this.$emit("versionGroup", this.selectedVersionGroup);
		this.$emit("selectedUnit", this.selectedUnit);
	}

	handleVersionGroup(value) {
		this.selectedVersionGroupId = value;
		this.$emit("versionGroup", this.selectedVersionGroup);
	}

	handleUnitChange(value) {
		this.selectedUnitId = value;
		this.$emit("selectedUnit", this.selectedUnit);
	}
}
